import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { EventPage } from '../event/event';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {

	client: any;
  eventDefault: any;
  eventListAtDay: any;
  eventListEndDay: any;

  constructor(public navCtrl: NavController, public params: NavParams, public eventProvider: EventData, public loadingCtrl: LoadingController, public events: Events) {
    this.client = this.params.get('client');
    this.eventDefault = this.params.get('event');

    this.eventProvider.getListEvents(this.client, true, this.eventDefault.id).then((result:any) => {
      this.eventListAtDay = result.sort((a, b) => {return a.defaultDate > b.defaultDate ? 1 : -1});
    });

    this.eventProvider.getListEvents(this.client, false).then((result: any) => {
      this.eventListEndDay = result.sort((a, b) => {return a.defaultDate < b.defaultDate ? 1 : -1});
    });
  }

  viewEvent(event) {
    if (event.redirect) {
      window.open(
        event.redirect,
        '_blank'
      );
    } else {
      let loader = this.loadingCtrl.create({
        dismissOnPageChange: true
      });
      loader.present();
      setTimeout(() => {
        this.events.publish('client:go-event', event);
      }, 600)
    }
  }

}
// end file



// WEBPACK FOOTER //
// ./src/pages/home/home.ts